import React from 'react';


const mainTitle = 'Selected Safety Information for WELIREG<sup>®</sup> (belzutifan) 40 mg tablets';
export const safetyWeliregCopy = {
mt: {
  safetyJobCode: 'US-BEL-00472 08/22', // Specific to safety panel


  title: 'Selected Safety Information for WELIREG',
  expandTitle: () => (
    <>
      <span className="blue-highlight">
        Selected Safety Information for WELIREG
        <sup className="r-size">®</sup> (belzutifan) 40 mg tablets
      </span>
    </>
  ),
  for: 'WELIREG® (belzutifan)',


  warningList: {
    title: 'WARNING: EMBRYO-FETAL TOXICITY',
    items: [
      'Exposure to WELIREG during pregnancy can cause embryo-fetal harm.',
      'Verify pregnancy status prior to the initiation of WELIREG.',
      'Advise patients of these risks and the need for effective non-hormonal contraception as WELIREG can render some hormonal contraceptives ineffective.',
    ],
  },


  sections: [
    {
      title: () => <>Anemia</>,
      layout: 'anemia',
      items: [
        () => (
          <>
            WELIREG can cause severe anemia that can require blood transfusion.
          </>
        ),
        () => (
          <>
            Monitor for anemia before initiation of, and periodically throughout,
            treatment with WELIREG. Transfuse patients as clinically indicated.
            Withhold, reduce dose, or permanently discontinue WELIREG based on severity.
          </>
        ),
        () => (
          <>
            In LITESPARK-004 (N=61), decreased hemoglobin occurred in 93% of patients with
            von Hippel-Lindau (VHL) disease and 7% had Grade 3 events. Median time to onset
            of anemia was 31 days (range: 1 day to 8.4 months).
          </>
        ),
        () => (
          <>
            The safety of erythropoiesis-stimulating agents (ESAs) for treatment of anemia
            in patients with VHL disease treated with WELIREG has not been established.
          </>
        ),
        () => (
          <>
            In LITESPARK-005 (n=372), decreased hemoglobin occurred in 88% of patients with
            advanced clear cell renal cell carcinoma (ccRCC) and 29% had Grade 3 events.
            Median time to onset of anemia was 29 days (range: 1 day to 16.6 months). Of the
            patients with anemia, 22% received transfusions only, 20% received
            erythropoiesis-stimulating agents (ESAs) only, and 12% received both transfusion
            and ESAs.
          </>
        ),
        () => (
          <>
            In LITESPARK-022 (n=915), decreased hemoglobin occurred in 95% of patients
            receiving adjuvant treatment for ccRCC and 11% had Grade 3 or higher events.
            Median time to onset of anemia was 42 days (range: 1 day to 11.1 months). Of the
            patients with anemia, 5% received transfusions only, 8% received
            erythropoiesis-stimulating agents (ESAs) only, and 1.3% received both transfusion
            and ESAs.
          </>
        ),
        () => (
          <>
            In LITESPARK-015 (n=72), anemia occurred in 96% of patients with pheochromocytoma
            or paraganglioma (PPGL) and 22% had Grade 3 events. Median time to onset of anemia
            was 29 days (range: 1 day to 22.1 months). Of the patients with anemia, 20%
            received transfusions only, 26% received erythropoiesis-stimulating agents (ESAs)
            only, and 6% received both transfusion and ESAs.
          </>
        ),
      ],
    },
    {
      title: () => <>Hypoxia</>,
      layout: 'hypoxia',
      items: [
        () => (
          <>
            WELIREG can cause severe hypoxia that may require discontinuation, supplemental
            oxygen, or hospitalization.
          </>
        ),
        () => (
          <>
            Monitor oxygen saturation before initiation of, and periodically throughout,
            treatment with WELIREG. For decreased oxygen saturation with exercise (eg, pulse
            oximeter &lt;88% or PaO₂ ≤55 mm Hg), consider withholding WELIREG until
            pulse oximetry with exercise is greater than 88%, then resume at the same or a
            reduced dose. For decreased oxygen saturation at rest (eg, pulse oximeter &lt;88%
            or PaO₂ ≤55 mm Hg) or when urgent intervention is indicated, withhold
            WELIREG until resolved and resume at a reduced dose or discontinue. For
            life-threatening or recurrent symptomatic hypoxia, permanently discontinue
            WELIREG. Advise patients to report signs and symptoms of hypoxia immediately to a
            health care provider.
          </>
        ),
        () => (
          <>
            In LITESPARK-004, hypoxia occurred in 1.6% of patients with VHL disease.
          </>
        ),
        () => (
          <>
            In LITESPARK-005, hypoxia occurred in 15% of patients with advanced ccRCC and 10%
            had Grade 3 events. Of the patients with hypoxia, 69% were treated with oxygen
            therapy. Median time to onset of hypoxia was 30.5 days (range: 1 day to 21.1
            months).
          </>
        ),
        () => (
          <>
            In LITESPARK-022, hypoxia occurred in 7% of patients receiving adjuvant treatment
            for ccRCC and 5% had Grade 3 or higher events. Of the patients with hypoxia, 47%
            were treated with oxygen therapy. Median time to onset of hypoxia was 93 days
            (range: 9 days to 11.7 months).
          </>
        ),
        () => (
          <>
            In LITESPARK-015, hypoxia occurred in 13% of patients with PPGL and 10% had Grade 3
            hypoxia. Median time to onset of hypoxia was 35 days (range: 6 days to 23.9
            months). Of the patients with hypoxia, 67% were treated with oxygen therapy.
          </>
        ),
      ],
    },
    {
      title: () => <>Embryo-Fetal Toxicity</>,
      layout: 'embryo',
      items: [
        () => (
          <>
            Based on findings in animals, WELIREG can cause fetal harm when administered to a
            pregnant woman.
          </>
        ),
        () => (
          <>
            Advise pregnant women and females of reproductive potential of the potential risk
            to the fetus. Advise females of reproductive potential to use effective
            non-hormonal contraception during treatment with WELIREG and for 1 week after the
            last dose. WELIREG can render some hormonal contraceptives ineffective. Advise
            male patients with female partners of reproductive potential to use effective
            contraception during treatment with WELIREG and for 1 week after the last dose.
          </>
        ),
      ],
    },
    {
      title: () => <>Adverse Reactions</>,
      layout: 'adverse',
      subTitle: [
        {
          titleHeading: () => <>Adverse Reactions in LITESPARK-004 (VHL disease)</>,
          content: [
            () => (
              <>
                Serious adverse reactions occurred in 15% of patients, including anemia,
                hypoxia, anaphylaxis reaction, retinal detachment, and central retinal vein
                occlusion (1 patient each).
              </>
            ),
            () => (
              <>
                WELIREG was permanently discontinued due to adverse reactions in 3.3% of
                patients for dizziness and opioid overdose (1.6% each).
              </>
            ),
            () => (
              <>
                Dosage interruptions due to an adverse reaction occurred in 39% of patients.
                Those which required dosage interruption in &gt;2% of patients were fatigue,
                decreased hemoglobin, anemia, nausea, abdominal pain, headache, and
                influenza-like illness.
              </>
            ),
            () => (
              <>
                Dose reductions due to an adverse reaction occurred in 13% of patients. The
                most frequently reported adverse reaction which required dose reduction was
                fatigue (7%).
              </>
            ),
            () => (
              <>
                The most common adverse reactions (≥25%), including laboratory abnormalities,
                that occurred in patients who received WELIREG were decreased hemoglobin
                (93%), fatigue (64%), increased creatinine (64%), headache (39%), dizziness
                (38%), increased glucose (34%), and nausea (31%).
              </>
            ),
          ],
        },
        {
          titleHeading: () => <>Adverse Reactions in LITESPARK-022 (Adjuvant ccRCC)</>,
          content: [
            () => (
              <>
                Serious adverse reactions occurred in 30% of patients receiving WELIREG in
                combination with KEYTRUDA. The most frequently reported serious adverse
                reactions (≥1%) were pneumonia (2%), hypoxia (1.9%), pneumonitis (1.6%),
                arrhythmia (1.5%), diarrhea (1.1%), and acute kidney injury (1.1%). Fatal
                adverse reactions occurred in 1.1% of patients who received WELIREG in
                combination with KEYTRUDA, including sepsis (0.1%).
              </>
            ),
            () => (
              <>
                WELIREG was permanently discontinued due to adverse reactions in 27% of
                patients. Adverse reactions which resulted in permanent discontinuation of
                WELIREG in ≥1% of patients included anemia (4%), fatigue (2.2%), rash (2%),
                increased alanine aminotransferase (ALT) (1.7%), hypoxia (1.6%), diarrhea
                (1.4%), pneumonitis (1.3%), increased aspartate aminotransferase (AST) (1.1%),
                and hepatic function abnormal (1%).
              </>
            ),
            () => (
              <>
                Dosage interruptions of WELIREG due to an adverse reaction occurred in 52% of
                patients. Of the patients who received WELIREG in combination with KEYTRUDA,
                30% were ≥65 years old and 5% were ≥75 years old. Dose interruptions of
                WELIREG occurred in 57% of patients ≥65 years of age and in 49% of younger
                patients. Adverse reactions which required dosage interruption of WELIREG in
                ≥2% of patients included anemia (25%), fatigue (3.7%), increased ALT (3.5%),
                diarrhea (3.4%), increased AST (3.4%), COVID-19 (2.6%), hypoxia (2.5%),
                pyrexia (2.5%), musculoskeletal pain (2.1%), and rash (2.1%).
              </>
            ),
            () => (
              <>
                Dose reductions of WELIREG due to an adverse reaction occurred in 34% of
                patients. Dose reductions of WELIREG occurred in 39% of patients ≥65 years of
                age and in 32% of younger patients. Adverse reactions which required dose
                reduction in ≥3% of patients included anemia (17%), hypoxia (3.5%), increased
                ALT (3.2%), and fatigue (3.1%).
              </>
            ),
            () => (
              <>
                The most common (≥25%) adverse reactions, including laboratory abnormalities,
                in patients who received WELIREG in combination with KEYTRUDA were decreased
                hemoglobin (95%), increased ALT (57%), fatigue (49%), increased AST (46%),
                decreased lymphocytes (38%), and increased alkaline phosphatase (29%).
              </>
            ),
          ],
        },
        {
          titleHeading: () => <>Adverse Reactions in LITESPARK-005 (Advanced ccRCC)</>,
          content: [
            () => (
              <>
                Serious adverse reactions occurred in 38% of patients. The most frequently
                reported serious adverse reactions (≥2%) were hypoxia (7%), anemia (5%),
                pneumonia (3.5%), hemorrhage (3%), and pleural effusion (2.2%). Fatal adverse
                reactions occurred in 3.2% of patients who received WELIREG, including sepsis
                (0.5%) and hemorrhage (0.5%).
              </>
            ),
            () => (
              <>
                WELIREG was permanently discontinued due to adverse reactions in 6% of
                patients. Adverse reactions which resulted in permanent discontinuation
                (≥0.5%) were hypoxia (1.1%), anemia (0.5%), and hemorrhage (0.5%).
              </>
            ),
            () => (
              <>
                Dosage interruptions due to an adverse reaction occurred in 39% of patients.
                Of the patients who received WELIREG, 28% were 65 to 74 years, and 10% were 75
                years and over. Dose interruptions occurred in 48% of patients ≥65 years of
                age and in 34% of younger patients. Adverse reactions which required dosage
                interruption in ≥2% of patients were anemia (8%), hypoxia (5%), COVID-19
                (4.3%), fatigue (3.2%), and hemorrhage (2.2%).
              </>
            ),
            () => (
              <>
                Dose reductions due to an adverse reaction occurred in 13% of patients. Dose
                reductions occurred in 18% of patients ≥65 years of age and in 10% of younger
                patients. The most frequently reported adverse reactions which required dose
                reduction (≥1%) were hypoxia (5%) and anemia (3.2%).
              </>
            ),
            () => (
              <>
                The most common adverse reactions (≥25%), including laboratory abnormalities,
                were decreased hemoglobin (88%), fatigue (43%), musculoskeletal pain (34%),
                increased creatinine (34%), decreased lymphocytes (34%), increased alanine
                aminotransferase (32%), decreased sodium (31%), increased potassium (29%), and
                increased aspartate aminotransferase (27%).
              </>
            ),
          ],
        },
        {
          titleHeading: () => <>Adverse Reactions in LITESPARK-015 (PPGL)</>,
          content: [
            () => (
              <>
                Serious adverse reactions occurred in 36% of patients. The most frequently
                reported serious adverse reactions (≥2%) were anemia and hypertension (4.2%
                each) and pyelonephritis, pneumonia, hypoxia, dyspnea, and hemorrhage (2.8%
                each).
              </>
            ),
            () => (
              <>
                WELIREG was permanently discontinued due to adverse reactions in 2 patients
                (2.8%). Adverse reactions which resulted in permanent discontinuation were
                increased alanine aminotransferase and paraparesis (1.4% each).
              </>
            ),
            () => (
              <>
                Dosage interruptions due to an adverse reaction occurred in 40% of patients.
                Of the patients who received WELIREG, 13% were ≥65 years old and 4.2% were ≥75
                years old. Adverse reactions which required dosage interruption in &gt;3% of
                patients were hypoxia, nausea, and fatigue (4.2% each).
              </>
            ),
            () => (
              <>
                Dose reductions due to an adverse reaction occurred in 14% of patients. The
                most frequently reported adverse reaction which required dose reduction was
                hypoxia (4.2%).
              </>
            ),
            () => (
              <>
                The most common (≥25%) adverse reactions, including laboratory abnormalities,
                that occurred in patients were anemia (96%), fatigue (56%), musculoskeletal
                pain (56%), decreased lymphocytes (54%), increased alanine aminotransferase
                (51%), increased aspartate aminotransferase (42%), increased calcium (34%),
                dyspnea (33%), increased potassium (31%), decreased leukocytes (30%), headache
                (29%), increased alkaline phosphatase (25%), dizziness (26%), and nausea
                (25%).
              </>
            ),
          ],
        },
      ],
    },
    {
      title: () => <>Drug Interactions</>,
      layout: 'drugInteractions',
      items: [
        () => (
          <>
            Coadministration of WELIREG with inhibitors of UGT2B17 or CYP2C19 increases plasma
            exposure of belzutifan, which may increase the incidence and severity of adverse
            reactions. Monitor for anemia and hypoxia and reduce the dosage of WELIREG as
            recommended.
          </>
        ),
        () => (
          <>
            Coadministration of WELIREG with CYP3A4 substrates decreases concentrations of
            CYP3A4 substrates, which may reduce the efficacy of these substrates or lead to
            therapeutic failures. Avoid coadministration with sensitive CYP3A4 substrates. If
            coadministration cannot be avoided, increase the sensitive CYP3A4 substrate dosage
            in accordance with its Prescribing Information. Coadministration of WELIREG with
            hormonal contraceptives may lead to contraceptive failure or an increase in
            breakthrough bleeding.
          </>
        ),
      ],
    },
    {
      title: () => <>Lactation</>,
      layout: 'lactation',
      items: [
        () => (
          <>
            Because of the potential for serious adverse reactions in breastfed children,
            advise women not to breastfeed during treatment with WELIREG and for 1 week after
            the last dose.
          </>
        ),
      ],
    },
    {
      title: () => <>Females and Males of Reproductive Potential</>,
      layout: 'reproductive',
      items: [
        () => (
          <>
            WELIREG can cause fetal harm when administered to a pregnant woman. Verify the
            pregnancy status of females of reproductive potential prior to initiating
            treatment with WELIREG.
          </>
        ),
        () => (
          <>
            Use of WELIREG may reduce the efficacy of hormonal contraceptives. Advise females
            of reproductive potential to use effective non-hormonal contraception during
            treatment with WELIREG and for 1 week after the last dose. Advise males with
            female partners of reproductive potential to use effective contraception during
            treatment with WELIREG and for 1 week after the last dose.
          </>
        ),
        () => (
          <>
            Based on findings in animals, WELIREG may impair fertility in males and females of
            reproductive potential and the reversibility of this effect is unknown.
          </>
        ),
      ],
    },
    {
      title: () => <>Pediatric Use</>,
      layout: 'pediatricBlock',
      items: [
        () => (
          <>
            Use of WELIREG in pediatric patients aged 12 years and older for PPGL is supported
            by evidence from an adequate and well-controlled study of WELIREG in adults with
            additional pharmacokinetic data demonstrating that belzutifan exposure is
            predicted to be within range of that observed in adults, and that the course of
            locally advanced, unresectable, or metastatic pheochromocytoma or paraganglioma is
            sufficiently similar in adults and pediatric patients to allow extrapolation of
            data in adults to pediatric patients.
          </>
        ),
        () => (
          <>
            The safety and effectiveness of WELIREG have not been established in pediatric
            patients with VHL or ccRCC, or in pediatric patients younger than 12 years of age
            with PPGL.
          </>
        ),
      ],
    },
    {
      title: () => <>Renal Impairment</>,
      layout: 'pediatricBlock',
      items: [
        () => (
          <>
            For patients with severe renal impairment (eGFR 15-29 mL/min estimated by MDRD),
            monitor for increased adverse reactions and modify the dosage as recommended.
          </>
        ),
      ],
    },
    {
      title: () => <>Hepatic Impairment</>,
      layout: 'pediatricBlock',
      items: [
        () => (
          <>
            For patients with moderate and severe hepatic impairment, monitor for increased
            adverse reactions and modify the dosage as recommended.
          </>
        ),
      ],
    },
  ],


  finalWarning: () => (
    <>
      <span className="spacing-expand">
        Before prescribing WELIREG, please read the accompanying{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.merck.com/product/usa/pi_circulars/w/welireg/welireg_pi.pdf"
        >
          Prescribing Information
        </a>
        , including the Boxed Warning about embryo-fetal toxicity. The{' '}
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.merck.com/product/usa/pi_circulars/w/welireg/welireg_mg.pdf"
        >
          Medication Guide
        </a>{' '}
        also is available.
      </span>
    </>
  ),
},
 arcc:{
   safetyJobCode: 'US-BEL-00472 08/22', // Specific to safety panel


 title:'Selected Safety Information for WELIREG',
 expandTitle: ()=> <><span className="blue-highlight">Selected Safety Information for WELIREG<sup className="r-size">®</sup> (belzutifan) 40 mg tablets</span></>,
 for: 'WELIREG® (belzutifan)',


 warningList: {
   title: 'WARNING: EMBRYO-FETAL TOXICITY',
   items: [
     'Exposure to WELIREG during pregnancy can cause embryo-fetal harm.',
     'Verify pregnancy status prior to the initiation of WELIREG.',
     'Advise patients of these risks and the need for effective non-hormonal contraception as WELIREG can render some hormonal contraceptives ineffective.',
   ],
 },


 sections: [
   {
     title: () => <>Anemia</>,
     items: [
       () => <>WELIREG can cause severe anemia that can require blood transfusion.<ul className="sub-list"><li>Monitor for anemia before initiation of, and periodically throughout, treatment. Transfuse patients as clinically indicated. For patients with hemoglobin &lt;8 g/dL, withhold WELIREG until ≥8 g/dL, then resume at the same or reduced dose or permanently discontinue WELIREG, depending on the severity of anemia. For life-threatening anemia or when urgent intervention is indicated, withhold WELIREG until hemoglobin ≥8 g/dL, then resume at a reduced dose or permanently discontinue WELIREG.</li></ul></>,
       () => <>In LITESPARK-004 (N=61), decreased hemoglobin occurred in 93% of patients with VHL disease and 7% had Grade 3 events. Median time to onset of anemia was 31 days (range: 1 day to 8.4 months).</>,
       () => <>The safety of erythropoiesis-stimulating agents (ESAs) for treatment of anemia in patients with VHL disease treated with WELIREG has not been established. </>,
       () => <>In LITESPARK-005 (n=372), decreased hemoglobin occurred in 88% of patients with advanced RCC with a clear cell component and 29% had Grade 3 events. Median time to onset of anemia was 29 days (range: 1 day to 16.6 months). Of the patients with anemia, 22% received transfusions only, 20% received erythropoiesis-stimulating agents (ESAs) only, and 12% received both transfusion and ESAs.</>,
       () => <>In LITESPARK-015, anemia occurred in 96% of patients with PPGL and 22% had Grade 3 events. Median time to onset of anemia was 29 days (range: 1 day to 22.1 months). Of the patients with anemia, 20% received transfusions only, 26% received erythropoiesis-stimulating agents (ESAs) only, and 6% received both transfusion and ESAs.</>,
     ],
   },
   {
     title: () => <>Hypoxia</>,
     items: [
       () => <>WELIREG can cause severe hypoxia that may require discontinuation, supplemental oxygen, or hospitalization.</>,
       () => <>Monitor oxygen saturation before initiation of, and periodically throughout, treatment. For decreased oxygen saturation with exercise (eg, pulse oximeter &lt;88% or PaO<sub>2</sub> ≤55 mm Hg), consider withholding WELIREG until pulse oximetry with exercise is greater than 88%, then resume at the same or a reduced dose. For decreased oxygen saturation at rest (eg, pulse oximeter &lt;88% or PaO<sub>2</sub> ≤55 mm Hg) or when urgent intervention is indicated, withhold WELIREG until resolved and resume at a reduced dose or discontinue. For life-threatening or recurrent symptomatic hypoxia, permanently discontinue WELIREG. Advise patients to report signs and symptoms of hypoxia immediately to a health care provider.</>,
       () => <>In LITESPARK-004, hypoxia occurred in 1.6% of patients.</>,
       () => <>In LITESPARK-005, hypoxia occurred in 15% of patients and 10% had Grade 3 events. Of the patients with hypoxia, 69% were treated with oxygen therapy. Median time to onset of hypoxia was 30.5 days (range: 1 day to 21.1 months).</>,
       () => <>In LITESPARK-015, hypoxia occurred in 13% of patients and 10% had Grade 3 hypoxia. Median time to onset of hypoxia was 35 days (range: 6 days to 23.9 months). Of the patients with hypoxia, 67% were treated with oxygen therapy.</>
     ],
   },
   {
     title: () => <>Embryo-Fetal Toxicity </>,
     items: [
       () => <>Based on findings in animals, WELIREG can cause fetal harm when administered to a pregnant woman.</>,
       () => <>Advise pregnant women and females of reproductive potential of the potential risk to the fetus. Advise females of reproductive potential to use effective non-hormonal contraception during treatment with WELIREG and for 1 week after the last dose. WELIREG can render some hormonal contraceptives ineffective. Advise male patients with female partners of reproductive potential to use effective contraception during treatment with WELIREG and for 1 week after the last dose.</>,
     ],
   },
   {
     title: () => <>Adverse Reactions</>,
     subTitle: [
       {
         titleHeading: () => <>Adverse Reactions in LITESPARK-004</>,
          content: [
           () => <>Serious adverse reactions occurred in 15% of patients, including anemia, hypoxia, anaphylaxis reaction, retinal detachment, and central retinal vein occlusion (1 patient each).</>,
           () => <>WELIREG was permanently discontinued due to adverse reactions in 3.3% of patients for dizziness and opioid overdose (1.6% each).</>,
           () => <>Dosage interruptions due to an adverse reaction occurred in 39% of patients. Those which required dosage interruption in &gt;2% of patients were fatigue, decreased hemoglobin, anemia, nausea, abdominal pain, headache, and influenza-like illness.</>,
           () => <>Dose reductions due to an adverse reaction occurred in 13% of patients. The most frequently reported adverse reaction which required dose reduction was fatigue (7%).</>,
           () => <>The most common adverse reactions (≥25%), including laboratory abnormalities, that occurred in patients who received WELIREG were decreased hemoglobin (93%), fatigue (64%), increased creatinine (64%), headache (39%), dizziness (38%), increased glucose (34%), and nausea (31%).</>,
          ],
       },
       {
         titleHeading: () => <>Adverse Reactions in LITESPARK-022</>,
         content: [
           () => <>Serious adverse reactions occurred in 30% of patients receiving WELIREG plus intravenous pembrolizumab (KEYTRUDA). Serious adverse reactions (≥1%) were hypoxia (1.9%), pneumonia (1.7%), acute kidney injury (1.0%), and pneumonitis (1.0%).</>,


           () => <>Permanent discontinuation of WELIREG, KEYTRUDA, or both due to adverse reactions occurred in 34% of patients who received WELIREG plus KEYTRUDA. WELIREG was permanently discontinued in 27% of patients, and both drugs were discontinued in 12% of patients. The most common adverse reactions leading to permanent discontinuation of WELIREG (≥1%) were anemia (4.0%), increased alanine aminotransferase (ALT) (1.7%), fatigue (1.6%), hypoxia (1.6%), increased aspartate aminotransferase (1.1%), diarrhea (1.1%), and hepatic function abnormal (1.0%).</>,


           () => <>Dosage interruptions of WELIREG, KEYTRUDA, or both due to an adverse reaction occurred in 60% of patients who received WELIREG plus KEYTRUDA. WELIREG was interrupted in 52% of patients, and both drugs were interrupted in 14% of patients. The most common adverse reactions resulting in interruption of WELIREG (≥2%) were anemia (25%), diarrhea (3.1%), COVID-19 (2.6%), hypoxia (2.5%), pyrexia (2.5%), and fatigue (2.4%).</>,


           () => <>Dose reductions of WELIREG due to an adverse reaction occurred in 34% of patients who received WELIREG plus KEYTRUDA. The most common adverse reactions which resulted in dose reduction of WELIREG (≥3%) were anemia (17%) and hypoxia (3.5%).</>,


           () => <>The most common adverse reactions (≥25%) for WELIREG in combination with KEYTRUDA were anemia (84%), fatigue (36%), and increased ALT (57%).</>,


           () => <>Of the patients with anemia receiving WELIREG plus KEYTRUDA, 5% received transfusions only, 8% received erythropoiesis-stimulating agents (ESA) only, and 1.3% received both transfusion and ESAs. Median time to onset was 42 days (range: 1 day to 11 months).</>,


           () => <>Of the patients receiving WELIREG plus KEYTRUDA, a clinically relevant adverse reaction (&lt;10%) was hypoxia (7%). Of these patients, 4.5% had Grade 3 events, 0.1% had Grade 4 events, and 47% were treated with oxygen therapy. Median time to onset was 93 days (range: 9 days to 12 months).</>,
         ]
       },
       {
         titleHeading: () => <>Adverse Reactions in LITESPARK-005</>,
         content: [
           () => <>Serious adverse reactions occurred in 38% of patients. The most frequently reported serious adverse reactions were hypoxia (7%), anemia (5%), pneumonia (3.5%), hemorrhage (3%), and pleural effusion (2.2%). Fatal adverse reactions occurred in 3.2% of patients who received WELIREG, including sepsis (0.5%) and hemorrhage (0.5%).</>,


           () => <>WELIREG was permanently discontinued due to adverse reactions in 6% of patients. Adverse reactions which resulted in permanent discontinuation (≥0.5%) were hypoxia (1.1%), anemia (0.5%), and hemorrhage (0.5%).</>,


           () => <>Dosage interruptions due to an adverse reaction occurred in 39% of patients. Of the patients who received WELIREG, 28% were 65 to 74 years, and 10% were 75 years and over. Dose interruptions occurred in 48% of patients ≥65 years of age and in 34% of younger patients. Adverse reactions which required dosage interruption in ≥2% of patients were anemia (8%), hypoxia (5%), COVID-19 (4.3%), fatigue (3.2%), and hemorrhage (2.2%).</>,


           () => <>Dose reductions due to an adverse reaction occurred in 13% of patients. Dose reductions occurred in 18% of patients ≥65 years of age and in 10% of younger patients. The most frequently reported adverse reactions which required dose reduction (≥1.0%) were hypoxia (5%) and anemia (3.2%).</>,


           () => <>The most common adverse reactions (≥25%), including laboratory abnormalities, were decreased hemoglobin (88%), fatigue (43%), musculoskeletal pain (34%), increased creatinine (34%), decreased lymphocytes (34%), increased alanine aminotransferase (32%), decreased sodium (31%), increased potassium (29%), and increased aspartate aminotransferase (27%).</>,


         ]
       },
       {
         titleHeading: () => <>Adverse Reactions in LITESPARK-015</>,
         content: [
           () => <>Serious adverse reactions occurred in 36% of patients. The most frequently reported serious adverse reactions were anemia and hypertension (4.2% each) and pyelonephritis, pneumonia, hypoxia, dyspnea, and hemorrhage (2.8% each).</>,


           () => <>WELIREG was permanently discontinued due to adverse reactions in 2 patients (2.8%). Adverse reactions which resulted in permanent discontinuation were increased alanine aminotransferase and paraparesis (1.4% each).</>,


           () => <>Dosage interruptions due to an adverse reaction occurred in 40% of patients. Of the patients who received WELIREG, 13% were ≥65 years old and 4.2% were ≥75 years. Adverse reactions which required dosage interruption in &gt;3% of patients were hypoxia, nausea, and fatigue (4.2% each).</>,


           () => <>Dose reductions due to an adverse reaction occurred in 14% of patients. The most frequently reported adverse reaction which required dose reduction was hypoxia (4.2%).</>,


           () => <>The most common (≥25%) adverse reactions, including laboratory abnormalities, that occurred in patients were anemia (96%), fatigue (56%), musculoskeletal pain (56%), decreased lymphocytes (54%), increased alanine aminotransferase (51%), increased aspartate aminotransferase (42%), increased calcium (34%), dyspnea (33%), increased potassium (31%), decreased leukocytes (30%), headache (29%), increased alkaline phosphatase (25%), dizziness (26%), and nausea (25%).</>,


         ]
       },


     ]
   },


   {
     title: () => <>Drug Interactions</>,
     items: [
       () => <>Coadministration of WELIREG with inhibitors of UGT2B17 or CYP2C19 increases plasma exposure of belzutifan, which may increase the incidence and severity of adverse reactions. Monitor for anemia and hypoxia and reduce the dosage of WELIREG as recommended.</>,
       () => <>Coadministration of WELIREG with CYP3A4 substrates decreases concentrations of CYP3A4 substrates, which may reduce the efficacy of these substrates or lead to therapeutic failures. Avoid coadministration with sensitive CYP3A4 substrates. If coadministration cannot be avoided, increase the sensitive CYP3A4 substrate dosage in accordance with its Prescribing Information. Coadministration of WELIREG with hormonal contraceptives may lead to contraceptive failure or an increase in breakthrough bleeding.</>,
     ],
   },
   {
     title: () => <>Lactation</>,
     items: [
       () => <>Because of the potential for serious adverse reactions in breastfed children, advise women not to breastfeed during treatment with WELIREG and for 1 week after the last dose.</>,
     ],
   },
   {
     title: () => <>Females and Males of Reproductive Potential</>,
     items: [
       () => <>WELIREG can cause fetal harm when administered to a pregnant woman. Verify the pregnancy status of females of reproductive potential prior to initiating treatment with WELIREG.</>,
       () => <>Use of WELIREG may reduce the efficacy of hormonal contraceptives. Advise females of reproductive potential to use effective non-hormonal contraception during treatment with WELIREG and for 1 week after the last dose. Advise males with female partners of reproductive potential to use effective contraception during treatment with WELIREG and for 1 week after the last dose.</>,
       () => <>Based on findings in animals, WELIREG may impair fertility in males and females of reproductive potential and the reversibility of this effect is unknown.</>,
     ],
   },
   {
     title: () => <>Pediatric Use</>,
     items: [
       () => <>Use of WELIREG in pediatric patients aged 12 years and older is supported by evidence from an adequate and well-controlled study of WELIREG in adults with additional pharmacokinetic data demonstrating that belzutifan exposure is predicted to be within range of that observed in adults, and that the course of locally advanced, unresectable, or metastatic pheochromocytoma or paraganglioma is sufficiently similar in adults and pediatric patients to allow extrapolation of data in adults to pediatric patients.</>,
     ],
   },
   {
     title: () => <>Renal Impairment</>,
     items: [
       () => <>For patients with severe renal impairment (eGFR 15-29 mL/min estimated by MDRD), monitor for increased adverse reactions and modify the dosage as recommended.</>,
     ],
   },
   {
     title: () => <>Hepatic Impairment</>,
     items: [
       () => <>For patients with moderate and severe hepatic impairment, monitor for increased adverse reactions and modify the dosage as recommended.</>,
     ],
   },
 ],


 finalWarning: () => <><span className='spacing-expand darkColor'>Before prescribing WELIREG, please read the accompanying <a target="_blank" href="https://www.merck.com/product/usa/pi_circulars/w/welireg/welireg_pi.pdf">Prescribing Information</a>, including the Boxed Warning about embryo-fetal toxicity. The <a target="_blank" href="https://www.merck.com/product/usa/pi_circulars/w/welireg/welireg_mg.pdf">Medication Guide</a> also is available.</span></>,
 },


};
export const safetyKeytrudaQlexCopy = {
 safetyJobCode: 'US-BEL-00472 08/22', // Specific to safety panel


 title:() => <><span className="green-highlight">Selected Safety Information for KEYTRUDA and KEYTRUDA</span> <span className="purple-highlight">QLEX</span></>,


// expandTitle: ()=> <><span className='green-highlight'>Selected Safety Information for KEYTRUDA<sup className="r-size">®</sup> (pembrolizumab) injection 100 mg and KEYTRUDA</span> <span className='purple-highlight'>QLEX<sup className="r-size">™</sup></span> <span className='green-highlight'>(pembrolizumab and berahyaluronidase alfa-pmph) subcutaneous injection 165 mg + 2,000 units/mL</span></>,
expandTitle: ()=> <><span className='green-highlight'>Selected Safety Information for KEYTRUDA<sup className="r-size">®</sup> (pembrolizumab) injection 100 mg and KEYTRUDA</span> <span className='purple-highlight'>QLEX<sup className="r-size">™</sup></span> <span className='green-highlight'>(pembrolizumab and berahyaluronidase alfa-pmph) subcutaneous injection 165 mg + 2,000 units/mL</span></>,
 for: 'WELIREG® (belzutifan)',


 previewText: {
   title: 'Contraindications',
   items: ["KEYTRUDA QLEX is contraindicated in patients with known hypersensitivity to berahyaluronidase alfa, hyaluronidase or to any of its excipients."]
 },


 sections: [
   {
     title: 'Contraindications',
     layout: 'contraindications',
     items: [
       () => <>KEYTRUDA QLEX is contraindicated in patients with known hypersensitivity to berahyaluronidase alfa, hyaluronidase or to any of its excipients.</>
     ],
   },
   {
     title: 'Severe and Fatal Immune-Mediated Adverse Reactions',
     items: [
       () => <>KEYTRUDA and KEYTRUDA QLEX are monoclonal antibodies that belong to a class of drugs that bind to either the programmed death receptor-1 (PD-1) or the programmed death ligand 1 (PD-L1), blocking the PD-1/PD-L1 pathway, thereby removing inhibition of the immune response, potentially breaking peripheral tolerance and inducing immune-mediated adverse reactions. Immune-mediated adverse reactions, which may be severe or fatal, can occur in any organ system or tissue, can affect more than one body system simultaneously, and can occur at any time after starting treatment or after discontinuation of treatment. Important immune-mediated adverse reactions listed here may not include all possible severe and fatal immune-mediated adverse reactions.</>,
       () => <>Monitor patients closely for symptoms and signs that may be clinical manifestations of underlying immune-mediated adverse reactions. Early identification and management are essential to ensure safe use of anti–PD-1/PD-L1 treatments. Evaluate liver enzymes, creatinine, and thyroid function at baseline and periodically during treatment. In cases of suspected immune-mediated adverse reactions, initiate appropriate workup to exclude alternative etiologies, including infection. Institute medical management promptly, including specialty consultation as appropriate.</>,
       () => <>Withhold or permanently discontinue KEYTRUDA and KEYTRUDA QLEX depending on severity of the immune-mediated adverse reaction. In general, if KEYTRUDA and KEYTRUDA QLEX require interruption or discontinuation, administer systemic corticosteroid therapy (1 to 2 mg/kg/day prednisone or equivalent) until improvement to Grade 1 or less. Upon improvement to Grade 1 or less, initiate corticosteroid taper and continue to taper over at least 1 month. Consider administration of other systemic immunosuppressants in patients whose adverse reactions are not controlled with corticosteroid therapy.</>
     ]
   },
   {
     layout: 'immuneMajorSubs',
     subTitle: [
       {
         titleHeading: 'Immune-Mediated Pneumonitis',
         content: [
           () => <>KEYTRUDA and KEYTRUDA QLEX can cause immune-mediated pneumonitis. The incidence is higher in patients who have received prior thoracic radiation. Immune-mediated pneumonitis occurred in 3.4% (94/2799) of patients receiving KEYTRUDA, including fatal (0.1%), Grade 4 (0.3%), Grade 3 (0.9%), and Grade 2 (1.3%) reactions. Systemic corticosteroids were required in 67% (63/94) of patients. Pneumonitis led to permanent discontinuation of KEYTRUDA in 1.3% (36) and withholding in 0.9% (26) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement; of these, 23% had recurrence. Pneumonitis resolved in 59% of the 94 patients. Immune-mediated pneumonitis occurred in 5% (13/251) of patients receiving KEYTRUDA QLEX in combination with chemotherapy, including fatal (0.4%), Grade 3 (2%), and Grade 2 (1.2%) adverse reactions.</>
         ]
       },
       {
         titleHeading: 'Immune-Mediated Colitis',
         content: [
           ()=><>KEYTRUDA and KEYTRUDA QLEX can cause immune-mediated colitis, which may present with diarrhea. Cytomegalovirus infection/reactivation has been reported in patients with corticosteroid-refractory immune-mediated colitis. In cases of corticosteroid-refractory colitis, consider repeating infectious workup to exclude alternative etiologies.</>,
           ()=><>Immune-mediated colitis occurred in 1.7% (48/2799) of patients receiving KEYTRUDA, including Grade 4 (&lt;0.1%), Grade 3 (1.1%), and Grade 2 (0.4%) reactions. Systemic corticosteroids were required in 69% (33/48); additional immunosuppressant therapy was required in 4.2% of patients. Colitis led to permanent discontinuation of KEYTRUDA in 0.5% (15) and withholding in 0.5% (13) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement; of these, 23% had recurrence. Colitis resolved in 85% of the 48 patients. Immune-mediated colitis occurred in 1.2% (3/251) of patients receiving KEYTRUDA QLEX in combination with chemotherapy, including Grade 3 (0.8%) and Grade 2 (0.4%) adverse reactions.</>
         ]
       },
       {
         titleHeading: 'Hepatotoxicity and Immune-Mediated Hepatitis',
         content:[
           ()=><>KEYTRUDA and KEYTRUDA QLEX can cause immune-mediated hepatitis. Immune-mediated hepatitis occurred in 0.7% (19/2799) of patients receiving KEYTRUDA, including Grade 4 (&lt;0.1%), Grade 3 (0.4%), and Grade 2 (0.1%) reactions. Systemic corticosteroids were required in 68% (13/19) of patients; additional immunosuppressant therapy was required in 11% of patients. Hepatitis led to permanent discontinuation of KEYTRUDA in 0.2% (6) and withholding in 0.3% (9) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement; of these, none had recurrence. Hepatitis resolved in 79% of the 19 patients. Immune-mediated hepatitis occurred in 0.4% (1/251) of patients receiving KEYTRUDA QLEX in combination with chemotherapy, including Grade 2 (0.4%) adverse reactions.</>
         ]
       }
     ]
     },


     {
       layout: 'immuneItalicSubs',
       subTitle: [
         {
           titleHeading: 'Immune-Mediated Endocrinopathies',
           italicHeading: 'Adrenal Insufficiency',
           content: [
             ()=><>KEYTRUDA and KEYTRUDA QLEX can cause primary or secondary adrenal insufficiency. For Grade 2 or higher, initiate symptomatic treatment, including hormone replacement as clinically indicated. Withhold KEYTRUDA and KEYTRUDA QLEX depending on severity. Adrenal insufficiency occurred in 0.8% (22/2799) of patients receiving KEYTRUDA, including Grade 4 (&lt;0.1%), Grade 3 (0.3%), and Grade 2 (0.3%) reactions. Systemic corticosteroids were required in 77% (17/22) of patients; of these, the majority remained on systemic corticosteroids. Adrenal insufficiency led to permanent discontinuation of KEYTRUDA in &lt;0.1% (1) and withholding in 0.3% (8) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement. Adrenal insufficiency occurred in 2% (5/251) of patients receiving KEYTRUDA QLEX in combination with chemotherapy, including Grade 3 (0.4%) and Grade 2 (0.8%) adverse reactions.</>,
             // ()=><>KEYTRUDA and KEYTRUDA QLEX can cause primary or secondary adrenal insufficiency. For Grade 2 or higher, initiate symptomatic treatment, including hormone replacement as clinically indicated. Withhold KEYTRUDA and KEYTRUDA QLEX depending on severity. Adrenal insufficiency occurred in 0.8% (22/2799) of patients receiving KEYTRUDA, including Grade 4 (&lt;0.1%), Grade 3 (0.3%), and Grade 2 (0.3%) reactions. Systemic corticosteroids were required in 77% (17/22) of patients; of these, the majority remained on systemic corticosteroids. Adrenal insufficiency led to permanent discontinuation of KEYTRUDA in &lt;0.1% (1) and withholding in 0.3% (8) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement. Adrenal insufficiency occurred in 2% (5/251) of patients receiving KEYTRUDA QLEX in combination with chemotherapy, including Grade 3 (0.4%) and Grade 2 (0.8%) adverse reactions.</>
           ]
         },
          {
           italicHeading: 'Hypophysitis',
           content: [
             ()=><>KEYTRUDA and KEYTRUDA QLEX can cause immune-mediated hypophysitis. Hypophysitis can present with acute symptoms associated with mass effect such as headache, photophobia, or visual field defects. Hypophysitis can cause hypopituitarism. Initiate hormone replacement as indicated. Withhold or permanently discontinue KEYTRUDA and KEYTRUDA QLEX depending on severity.</>,
             ()=><>Hypophysitis occurred in 0.6% (17/2799) of patients receiving KEYTRUDA, including Grade 4 (&lt;0.1%), Grade 3 (0.3%), and Grade 2 (0.2%) reactions. Systemic corticosteroids were required in 94% (16/17) of patients; of these, the majority remained on systemic corticosteroids. Hypophysitis led to permanent discontinuation of KEYTRUDA in 0.1% (4) and withholding in 0.3% (7) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement.</>
           ]
         },
          {
           italicHeading: 'Thyroid Disorders',
           content: [
             ()=><>KEYTRUDA and KEYTRUDA QLEX can cause immune-mediated thyroid disorders. Thyroiditis can present with or without endocrinopathy. Hypothyroidism can follow hyperthyroidism. Initiate hormone replacement for hypothyroidism or institute medical management of hyperthyroidism as clinically indicated. Withhold or permanently discontinue KEYTRUDA and KEYTRUDA QLEX depending on severity.</>,
             ()=><>Thyroiditis occurred in 0.6% (16/2799) of patients receiving KEYTRUDA, including Grade 2 (0.3%). None discontinued, but KEYTRUDA was withheld in &lt;0.1% (1) of patients.</>,
             // ()=><>Hyperthyroidism occurred in 3.4% (96/2799) of patients receiving KEYTRUDA, including Grade 3 (0.1%) and Grade 2 (0.8%). It led to permanent discontinuation of KEYTRUDA in &lt;0.1% (2) and withholding in 0.3% (7) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement. Hypothyroidism occurred in 8% (237/2799) of patients receiving KEYTRUDA, including Grade 3 (0.1%) and Grade 2 (6.2%). It led to permanent discontinuation of KEYTRUDA in &lt;0.1% (1) and withholding in 0.5% (14) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement. The majority of patients with hypothyroidism required long-term thyroid hormone replacement.</>,
             () => <>Hyperthyroidism occurred in 3.4% (96/2799) of patients receiving KEYTRUDA, including Grade 3 (0.1%) and Grade 2 (0.8%). It led to permanent discontinuation of KEYTRUDA in &lt;0.1% (2) and withholding in 0.3% (7) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement. Hypothyroidism occurred in 8% (237/2799) of patients receiving KEYTRUDA, including Grade 3 (0.1%) and Grade 2 (6.2%). It led to permanent discontinuation of KEYTRUDA in &lt;0.1% (1) and withholding in 0.5% (14) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement. The majority of patients with hypothyroidism required long-term thyroid hormone replacement.</>,
             () => <>Thyroiditis occurred in 0.4% (1/251) of patients receiving KEYTRUDA QLEX in combination with chemotherapy, including Grade 2 (0.4%). Hyperthyroidism occurred in 8% (20/251) of patients receiving KEYTRUDA QLEX in combination with chemotherapy, including Grade 2 (3.2%). Hypothyroidism occurred in 14% (35/251) of patients receiving KEYTRUDA QLEX in combination with chemotherapy, including Grade 2 (11%).</>,
           ]
         },
         {
           italicHeading: 'Type 1 Diabetes Mellitus (DM), Which Can Present With Diabetic Ketoacidosis',
           content:[
             ()=><>Monitor patients for hyperglycemia or other signs and symptoms of diabetes. Initiate treatment with insulin as clinically indicated. Withhold KEYTRUDA and KEYTRUDA QLEX depending on severity. Type 1 DM occurred in 0.2% (6/2799) of patients receiving KEYTRUDA. It led to permanent discontinuation in &lt;0.1% (1) and withholding of KEYTRUDA in &lt;0.1% (1) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement. Type 1 DM occurred in 0.4% (1/251) of patients receiving KEYTRUDA QLEX in combination with chemotherapy.</>
           ],
         },
       ],
     },
     {
       layout: 'immuneMajorSubs',
       subTitle: [
         {
           titleHeading: 'Immune-Mediated Nephritis With Renal Dysfunction',
           content: [
             ()=><>KEYTRUDA and KEYTRUDA QLEX can cause immune-mediated nephritis.</>,
             ()=><>Immune-mediated nephritis occurred in 0.3% (9/2799) of patients receiving KEYTRUDA, including Grade 4 (&lt;0.1%), Grade 3 (0.1%), and Grade 2 (0.1%) reactions. Systemic corticosteroids were required in 89% (8/9) of patients. Nephritis led to permanent discontinuation of KEYTRUDA in 0.1% (3) and withholding in 0.1% (3) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement; of these, none had recurrence. Nephritis resolved in 56% of the 9 patients.</>
           ]
         },
         {
           titleHeading: 'Immune-Mediated Dermatologic Adverse Reactions',
           content: [
             ()=><>KEYTRUDA and KEYTRUDA QLEX can cause immune-mediated rash or dermatitis. Exfoliative dermatitis, including Stevens-Johnson syndrome, drug rash with eosinophilia and systemic symptoms, and toxic epidermal necrolysis, has occurred with anti–PD-1/PD-L1 treatments. Topical emollients and/or topical corticosteroids may be adequate to treat mild to moderate nonexfoliative rashes. Withhold or permanently discontinue KEYTRUDA and KEYTRUDA QLEX depending on severity.</>,
             ()=><>Immune-mediated dermatologic adverse reactions occurred in 1.4% (38/2799) of patients receiving KEYTRUDA, including Grade 3 (1%) and Grade 2 (0.1%) reactions. Systemic corticosteroids were required in 40% (15/38) of patients. These reactions led to permanent discontinuation in 0.1% (2) and withholding of KEYTRUDA in 0.6% (16) of patients. All patients who were withheld reinitiated KEYTRUDA after symptom improvement; of these, 6% had recurrence. The reactions resolved in 79% of the 38 patients. Immune-mediated dermatologic adverse reactions occurred in 1.6% (4/251) of patients receiving KEYTRUDA QLEX in combination with chemotherapy, including Grade 4 (0.8%) and Grade 3 (0.8%) adverse reactions.</>
           ]
         },
        {
          titleHeading: 'Other Immune-Mediated Adverse Reactions',
          content:[
            ()=><>The following clinically significant immune-mediated adverse reactions occurred at an incidence of &lt;1% (unless otherwise noted) in patients who received KEYTRUDA, KEYTRUDA QLEX, or were reported with the use of other anti–PD-1/PD-L1 treatments. Severe or fatal cases have been reported for some of these adverse reactions. <em>Cardiac/Vascular</em>: Myocarditis, pericarditis, vasculitis; <em>Nervous System</em>: Meningitis, encephalitis, myelitis and demyelination, myasthenic syndrome/myasthenia gravis (including exacerbation), Guillain-Barré syndrome, nerve paresis, autoimmune neuropathy; <em>Ocular</em>: Uveitis, iritis and other ocular inflammatory toxicities can occur. Some cases can be associated with retinal detachment. Various grades of visual impairment, including blindness, can occur. If uveitis occurs in combination with other immune-mediated adverse reactions, consider a Vogt-Koyanagi-Harada-like syndrome, as this may require treatment with systemic steroids to reduce the risk of permanent vision loss; <em>Gastrointestinal</em>: Pancreatitis, to include increases in serum amylase and lipase levels, gastritis (2.8%), duodenitis; <em>Musculoskeletal and Connective Tissue</em>: Myositis/polymyositis, rhabdomyolysis (and associated sequelae, including renal failure), arthritis (1.5%), polymyalgia rheumatica; <em>Endocrine</em>: Hypoparathyroidism; <em>Hematologic/Immune</em>: Hemolytic anemia, aplastic anemia, hemophagocytic lymphohistiocytosis, systemic inflammatory response syndrome, histiocytic necrotizing lymphadenitis (Kikuchi lymphadenitis), sarcoidosis, immune thrombocytopenic purpura, solid organ transplant rejection, other transplant (including corneal graft) rejection; <em>Other</em>: Myocarditis-Myositis-Myasthenia Gravis (or Myasthenia-Like) Overlap syndrome, reported as the co-occurrence of either two or all three adverse reactions.</>
          ]
        }
       ],


     },
     {
       layout: 'sectionGap8',
       group: [
         {
           title: 'Hypersensitivity and Infusion- or Administration-Related Reactions',
           layout: 'standardTight',
           items: [
             ()=><>KEYTRUDA and KEYTRUDA QLEX can cause severe or life-threatening administration-related reactions, including hypersensitivity and anaphylaxis. With KEYTRUDA and KEYTRUDA QLEX, monitor for signs and symptoms of infusion- and administration-related systemic reactions including rigors, chills, wheezing, pruritus, flushing, rash, hypotension, hypoxemia, and fever. Infusion-related reactions have been reported in 0.2% of 2799 patients receiving KEYTRUDA. Interrupt or slow the rate of infusion for Grade 1 or Grade 2 reactions. For Grade 3 or Grade 4 reactions, stop infusion and permanently discontinue KEYTRUDA. Hypersensitivity and administration-related systemic reactions occurred in 3.2% (8/251) of patients receiving KEYTRUDA QLEX in combination with platinum doublet chemotherapy, including Grade 2 (2.8%). Interrupt injection (if not already fully administered) and resume if symptoms resolve for mild or moderate systemic reactions. For severe or life-threatening systemic reactions, stop injection and permanently discontinue KEYTRUDA QLEX.</>,
           ]
         },
         {
           title: 'Complications of Allogeneic Hematopoietic Stem Cell Transplantation (HSCT)',
           items: [
             ()=><>Fatal and other serious complications can occur in patients who receive allogeneic HSCT before or after anti–PD-1/PD-L1 treatments. Transplant-related complications include hyperacute graft-versus-host disease (GVHD), acute and chronic GVHD, hepatic veno-occlusive disease after reduced intensity conditioning, and steroid-requiring febrile syndrome (without an identified infectious cause). These complications may occur despite intervening therapy between anti–PD-1/PD-L1 treatments and allogeneic HSCT. Follow patients closely for evidence of these complications and intervene promptly. Consider the benefit vs risks of using anti–PD-1/PD-L1 treatments prior to or after an allogeneic HSCT.</>,
           ]
         },
       ],
     },
     {
       title: 'Increased Mortality in Patients With Multiple Myeloma',
       items: [
         ()=><>In trials in patients with multiple myeloma, the addition of KEYTRUDA to a thalidomide analogue plus dexamethasone resulted in increased mortality. Treatment of these patients with an anti–PD-1/PD-L1 treatment in this combination is not recommended outside of controlled trials.</>,


       ]
     },
     {
       title: 'Embryofetal Toxicity',
       items: [
         ()=><>Based on their mechanism of action, KEYTRUDA and KEYTRUDA QLEX can each cause fetal harm when administered to a pregnant woman. Advise women of this potential risk. In females of reproductive potential, verify pregnancy status prior to initiating KEYTRUDA or KEYTRUDA QLEX and advise them to use effective contraception during treatment and for 4 months after the last dose.</>,


       ]
     },
    {
      title: 'Adverse Reactions',
      items: [
        ()=><>In study MK-3475A-D77, when KEYTRUDA QLEX was administered with chemotherapy in metastatic non–small cell lung cancer (NSCLC), serious adverse reactions occurred in 39% of patients. Serious adverse reactions in ≥1% of patients who received KEYTRUDA QLEX were pneumonia (10%), thrombocytopenia (4%), febrile neutropenia (4%), neutropenia (2.8%), musculoskeletal pain (2%), pneumonitis (2%), diarrhea (1.6%), rash (1.2%), respiratory failure (1.2%), and anemia (1.2%). Fatal adverse reactions occurred in 10% of patients including pneumonia (3.2%), neutropenic sepsis (2%), death not otherwise specified (1.6%), respiratory failure (1.2%), parotitis (0.4%), pneumonitis (0.4%), pneumothorax (0.4%), pulmonary embolism (0.4%), neutropenic colitis (0.4%), and seizure (0.4%). KEYTRUDA QLEX was permanently discontinued due to an adverse reaction in 16% of 251 patients. Adverse reactions which resulted in permanent discontinuation of KEYTRUDA QLEX in ≥2% of patients included pneumonia and pneumonitis. Dosage interruptions of KEYTRUDA QLEX due to an adverse reaction occurred in 45% of patients. Adverse reactions which required dosage interruption in ≥2% of patients included neutropenia, anemia, thrombocytopenia, pneumonia, rash, and increased aspartate aminotransferase. The most common adverse reactions (≥20%) were nausea (25%), fatigue (25%), and musculoskeletal pain (21%).</>,
        ()=><>In LITESPARK-022, when KEYTRUDA was administered in combination with WELIREG for the adjuvant treatment of renal cell carcinoma with a clear cell component (ccRCC) (n=915), serious adverse reactions occurred in 30% of patients. Serious adverse reactions in ≥1% of patients included pneumonia (2%), hypoxia (1.9%), pneumonitis (1.6%), arrhythmia (1.5%), diarrhea (1.1%), and acute kidney injury (1.1%). Fatal adverse reactions occurred in 1.1% of patients who received KEYTRUDA in combination with WELIREG, including sepsis (0.1%).</>,
        ()=><>Permanent discontinuation of KEYTRUDA due to an adverse reaction occurred in 23% of patients. Adverse reactions which resulted in permanent discontinuation of KEYTRUDA in ≥1% of patients included increased alanine aminotransferase (ALT) (4.5%), increased aspartate aminotransferase (AST) (3%), pneumonitis (2.4%), diarrhea (2.4%), and rash (1.5%).</>,
        ()=><>Dose interruptions of KEYTRUDA due to an adverse reaction occurred in 29% of patients. Adverse reactions which required dosage interruption of KEYTRUDA in ≥2% patients included anemia (3.2%), diarrhea (3%), increased ALT (3%), and increased AST (2.5%).</>,
        ()=><>The most common (≥25%) adverse reactions, including laboratory abnormalities, in patients who received KEYTRUDA in combination with WELIREG were decreased hemoglobin (95%), increased ALT (57%), fatigue (49%), increased AST (46%), decreased lymphocytes (38%), and increased alkaline phosphatase (29%).</>,
      ]
    },
     {
       title: 'Lactation',
       layout: 'standardTight',
       items: [
       ()=><>Because of the potential for serious adverse reactions in breastfed children, advise women not to breastfeed during treatment and for 4 months after the last dose.</>
       ]
     }
   ],
   finalWarning: () => <><span className='spacing-expand'>Before prescribing KEYTRUDA or KEYTRUDA QLEX, please read the accompanying Prescribing Information for <a target="_blank" href="https://www.merck.com/product/usa/pi_circulars/k/keytruda/keytruda_pi.pdf" className='green-highlight'>KEYTRUDA</a> and <a target="_blank" href="https://www.merck.com/product/usa/pi_circulars/k/keytruda_qlex/keytruda_qlex_pi.pdf" className='purple-highlight'><span className='green-highlight'>KEYTRUDA</span> QLEX</a>. The Medication Guides for <a target="_blank" href="http://www.merck.com/product/usa/pi_circulars/k/keytruda/keytruda_mg.pdf" className='green-highlight'>KEYTRUDA</a> and <a target="_blank" href="https://www.merck.com/product/usa/pi_circulars/k/keytruda_qlex/keytruda_qlex_mg.pdf" className='purple-highlight'><span className='green-highlight'>KEYTRUDA</span> QLEX</a> also are available.</span></>,
};
